import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const AuthActionPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const mode = searchParams.get('mode');
        // Get the full query string (oobCode, apiKey, etc.) to pass along
        const params = searchParams.toString();

        // If a continueUrl is present and points to a trusted Guard domain,
        // hand off the full action URL to that app instead of handling it here.
        const continueUrl = searchParams.get('continueUrl');
        const GUARD_ORIGINS = [
        'https://sds-pilot-portal-dev-guard.web.app',
        'https://sds-pilot-portal-guard.web.app',
        'https://guard.savvai.ai',
   ];
                if (continueUrl) {
          try {
            const targetUrl = new URL(continueUrl);
            const trustedGuardOrigin = GUARD_ORIGINS.includes(targetUrl.origin);

            if (trustedGuardOrigin) {
              ['mode', 'oobCode', 'apiKey', 'lang'].forEach((key) => {
                const value = searchParams.get(key);
                if (value) targetUrl.searchParams.set(key, value);
              });

              window.location.href = targetUrl.toString();
              return;
            }
          } catch (err) {
            console.warn('Invalid continueUrl in auth action:', continueUrl);
          }
        }

        if (mode === 'resetPassword') {
            // Redirect to the Password Reset Page
            navigate(`/reset-password?${params}`, { replace: true });
        } else if (mode === 'verifyEmail') {
            // Redirect to the Email Verification Page
            navigate(`/verify-email?${params}`, { replace: true });
        } else {
            // Unknown mode or recoverEmail, send to login
            console.warn('Unknown auth mode:', mode);
            navigate('/login');
        }
    }, [searchParams, navigate]);

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh' 
        }}>
            <CircularProgress />
            <Typography sx={{ mt: 2, color: 'text.secondary' }}>
                Redirecting...
            </Typography>
        </Box>
    );
};

export default AuthActionPage;